var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#2aabe4",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9 7h6.2a.9.9 0 01.9.9v6.2a.9.9 0 01-.9.9H7.9a.9.9 0 01-.9-.9V7.9a.9.9 0 01.9-.9zm10 0h6.2a.9.9 0 01.9.9v6.2a.9.9 0 01-.9.9h-6.2a.9.9 0 01-.9-.9V7.9a.9.9 0 01.9-.9zm0 10h6.2a.9.9 0 01.9.9v6.2a.9.9 0 01-.9.9h-6.2a.9.9 0 01-.9-.9v-6.2a.9.9 0 01.9-.9zm-10 0h6.2a.9.9 0 01.9.9v6.2a.9.9 0 01-.9.9H7.9a.9.9 0 01-.9-.9v-6.2a.9.9 0 01.9-.9z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlcn);
export default __webpack_public_path__ + "static/media/blcn.d3cfa12e3bd775fed0633a6ff606d9ba.svg";
export { ForwardRef as ReactComponent };